import { render, staticRenderFns } from "./banner-cmp.vue?vue&type=template&id=4c959c80"
import script from "./banner-cmp.vue?vue&type=script&lang=js"
export * from "./banner-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports